import ConfirmationModalModule, { ConfirmationModalType} from "./confirmationModal-module";

export {ConfirmationModalModule, ConfirmationModalType};
